import "./calorie_counter.scss";

const CalorieCounter = () => {
  return (
    <iframe
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      className={"iframe"}
      src="https://tools.changaal.com/"
    ></iframe>
  );
};

export default CalorieCounter;
